// hooks/useSubscription.js
import React from 'react';
import { supabase } from '../lib/supabase';

export const useSubscription = (userId) => {
  const [hasActivePack, setHasActivePack] = React.useState(null); // null = loading
  const [isLoading, setIsLoading] = React.useState(true);
  const [currentPack, setCurrentPack] = React.useState(null);

  const checkSubscription = async () => {
    if (!userId) {
      setIsLoading(false);
      setHasActivePack(false);
      return;
    }

    try {
      // Check if user has a package assigned
      const { data, error } = await supabase
        .from('user_profiles')
        .select('package_id, commercial_packages(*)')
        .eq('id', userId)
        .single();

      if (error) throw error;

      const hasPack = !!data?.package_id;
      setHasActivePack(hasPack);
      setCurrentPack(hasPack ? data.commercial_packages : null);
      
    } catch (error) {
      console.error('Error checking subscription:', error);
      setHasActivePack(false);
      setCurrentPack(null);
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    checkSubscription();

    // Subscribe to realtime changes
    const subscription = supabase
      .channel('user-pack-changes')
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'user_profiles',
          filter: `id=eq.${userId}`,
        },
        (payload) => {
          console.log('Pack changed:', payload);
          checkSubscription();
        }
      )
      .subscribe();

    return () => {
      subscription.unsubscribe();
    };
  }, [userId]);

  return { hasActivePack, isLoading, currentPack, refetch: checkSubscription };
};